export default __webpack_public_path__ + "static/media/Header.7cfd6d72.png";